// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "sonner";
// import DealCard from "../Vendor/VendorDeal/DealCard/DealCard";

// const ExclusiveDeals = ({ dealsData, error, isLoading, refetch }) => {
//   const [visibleDeals, setVisibleDeals] = useState([]);

//   const navigate = useNavigate();

//   // Update visible deals based on screen size
//   useEffect(() => {
//     if (!dealsData?.deals) return;

//     const updateVisibleDeals = () => {
//       const isMobile = window.innerWidth < 768;
//       const limit = isMobile ? 6 : 5;
//       setVisibleDeals(dealsData.deals.slice(0, limit));
//     };

//     updateVisibleDeals();
//     window.addEventListener("resize", updateVisibleDeals);
//     return () => window.removeEventListener("resize", updateVisibleDeals);
//   }, [dealsData]);

//   const handleDealClick = (dealId) => {
//     navigate(`/DealDetails/${dealId}`);
//   };

//   // Show error toast if there's an error
//   useEffect(() => {
//     if (error) {
//       toast.error("Failed to load deals. Please check your connection.");
//     }
//   }, [error]);

//   if (isLoading) {
//     return (
//       <div className="flex items-center justify-center">
//         <div className="flex flex-col items-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#FE7A3A]"></div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="bg-white flex flex-col items-center justify-center text-gray-700 text-xl p-4">
//         <p className="text-red-500">
//           Error: Failed to load deals. Please try again later.
//         </p>
//         <button
//           onClick={refetch}
//           className="mt-4 px-4 py-2 bg-[#FE7A3A] text-white rounded-lg hover:bg-orange-500"
//         >
//           Retry Loading Deals
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-white">
//       <div className="py-8 px-4 sm:px-6 md:px-8 max-w-screen-2xl mx-auto">
//         <div className="flex justify-between items-center mb-6">
//           <div>
//             <h2 className="text-xl md:text-2xl leading-8 md:leading-10 font-bold text-gray-900">
//               Today's Best Deals
//             </h2>
//             <p className="text-sm md:text-base leading-6 md:leading-7 text-gray-700">
//               Discover amazing offers from local vendors
//             </p>
//           </div>
          
//         </div>

//         <div
//           className="
//             grid gap-4
//             grid-cols-2
//             sm:grid-cols-2
//             md:grid-cols-3
//             lg:grid-cols-4
//             xl:grid-cols-5
//             2xl:grid-cols-5
//           "
//         >
//           {visibleDeals.length > 0 ? (
//             visibleDeals.map((deal) => (
//               <DealCard
//                 key={deal.deal_uuid}
//                 deal={deal}
//                 onClick={handleDealClick}
//               />
//             ))
//           ) : (
//             <div className="col-span-full text-center text-gray-600 p-8">
//               <p className="text-lg">
//                 No deals available at the moment. Check back soon!
//               </p>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ExclusiveDeals;

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import DealCard from "../Vendor/VendorDeal/DealCard/DealCard";

const ExclusiveDeals = ({ dealsData, error, isLoading, refetch }) => {
  const [visibleDeals, setVisibleDeals] = useState([]);
  const [showAllDeals, setShowAllDeals] = useState(false); // ✅ Added state

  const navigate = useNavigate();

  // Update visible deals based on screen size and view toggle
  useEffect(() => {
    if (!dealsData?.deals) return;

    const updateVisibleDeals = () => {
      const isMobile = window.innerWidth < 768;
      const limit = isMobile ? 6 : 5;
      setVisibleDeals(showAllDeals ? dealsData.deals : dealsData.deals.slice(0, limit));
    };

    updateVisibleDeals();
    window.addEventListener("resize", updateVisibleDeals);
    return () => window.removeEventListener("resize", updateVisibleDeals);
  }, [dealsData, showAllDeals]); // ✅ Added showAllDeals as dependency

  const handleToggleView = () => {
    setShowAllDeals((prev) => !prev);
  };

  const handleDealClick = (dealId) => {
    navigate(`/DealDetails/${dealId}`);
  };

  // Show error toast if there's an error
  useEffect(() => {
    if (error) {
      toast.error("Failed to load deals. Please check your connection.");
    }
  }, [error]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#FE7A3A]"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white flex flex-col items-center justify-center text-gray-700 text-xl p-4">
        <p className="text-red-500">
          Error: Failed to load deals. Please try again later.
        </p>
        <button
          onClick={refetch}
          className="mt-4 px-4 py-2 bg-[#FE7A3A] text-white rounded-lg hover:bg-orange-500"
        >
          Retry Loading Deals
        </button>
      </div>
    );
  }

  const shouldShowToggleButton = dealsData?.deals?.length > (window.innerWidth < 768 ? 6 : 5);

  return (
    <div className="bg-white">
      <div className="py-8 px-4 sm:px-6 md:px-8 max-w-screen-2xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h2 className="text-xl md:text-2xl leading-8 md:leading-10 font-bold text-gray-900">
              Today's Best Deals
            </h2>
            <p className="text-sm md:text-base leading-6 md:leading-7 text-gray-700">
              Discover amazing offers from local vendors
            </p>
          </div>

          {shouldShowToggleButton && (
            <button
              onClick={handleToggleView}
              className="text-base font-semibold text-orange-500 hover:text-orange-600 transition-colors duration-200"
            >
              {showAllDeals ? "View Less" : "View All"}
            </button>
          )}
        </div>

        <div
          className="
            grid gap-4
            grid-cols-2
            sm:grid-cols-2
            md:grid-cols-3
            lg:grid-cols-4
            xl:grid-cols-5
            2xl:grid-cols-5
          "
        >
          {visibleDeals.length > 0 ? (
            visibleDeals.map((deal) => (
              <DealCard
                key={deal.deal_uuid}
                deal={deal}
                onClick={() => handleDealClick(deal.deal_uuid)}
              />
            ))
          ) : (
            <div className="col-span-full text-center text-gray-600 p-8">
              <p className="text-lg">
                No deals available at the moment. Check back soon!
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExclusiveDeals;
